import { render, staticRenderFns } from "./ReassignReviewer.vue?vue&type=template&id=b01aea12"
import script from "./ReassignReviewer.vue?vue&type=script&lang=js"
export * from "./ReassignReviewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports